export const auditPage = state => state.auditList.page
export const ccPage = state => state.ccList.page
export const historyPage = state => state.historyList.page
export const sealPage = state => state.sealList.page
export const filePage = state => state.fileList.page
export const currentContract = state => state.contract
export const currentSealOut = state => state.sealOut



// WEBPACK FOOTER //
// ./src/vuex/getters.js